import { styled } from '@mui/material/styles';
import Button, { ButtonProps } from '@mui/material/Button';
import { alpha } from '@mui/material/styles';

const AsmubipButton = styled(Button)<ButtonProps>(({ theme, size, variant, fullWidth }) => ({
  backgroundColor: theme.palette.button.bg,
  color: theme.palette.primary.main,
  height: '40px',
  fontSize: '1rem',
  boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.30), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)',
  textTransform: 'none',
  ...(size === 'large' && {
    ...(!fullWidth && { width: '202px' }),
    borderRadius: '100px',
  }),
  ...(size === 'medium' && {
    ...(!fullWidth && { width: '160px' }),
    borderRadius: '80px',
  }),
  '&:hover': {
    backgroundColor: theme.palette.button.bg,
    color: theme.palette.primary.main,
    // transform: 'translateY(-2px)',
    // boxShadow: '0px 3px 2px 0px rgba(0, 0, 0, 0.30), 0px 3px 3px 1px rgba(0, 0, 0, 0.15)',
  },
  '&:disabled': {
    color: theme.palette.text.dark,
    backgroundColor: theme.palette.button.disabled,
    boxShadow: 'none',
    transform: 'none',
    cursor: 'not-allowed',
  },
  ...(variant === 'contained-dark' && {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      transform: 'translateY(-2px)',
      //boxShadow: 'none',
    },
  }),
  ...(variant === 'contained-bottom-bar' && {
    backgroundColor: theme.palette.primary.variants['90'],
    color: theme.palette.icon.primary,
    width: '100%',
    margin: 0,
    borderRadius: 100,
    boxShadow: 'none',
    transform: 'none',
    '&:hover': {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    '&:disabled': {
      color: alpha(theme.palette.text.dark, 0.12),
      backgroundColor: theme.palette.button.disabled,
      cursor: 'not-allowed',
    },
  }),
  ...(variant === 'outlined' && {
    boxShadow: 'none',
    borderColor: theme.palette.outline.main,
    backgroundColor: theme.palette.background.default,
  }),
  ...(variant === 'contained-secondary' && {
    backgroundColor: theme.palette.primary.variants['90'],
    color: theme.palette.secondary.variants['10'],
    boxShadow: 'none',
  }),
  ...(variant === 'contained-help' && {
    width: 'fit-content',
    backgroundColor: theme.palette.secondary.variants['90'],
    color: theme.palette.secondary.variants['10'],
    margin: 0,
  }),
  ...(variant === 'contained-add' && {
    width: 'fit-content',
    margin: 0,
  }),
  ...(variant === 'text' && {
    backgroundColor: 'none',
    color: theme.palette.primary.contrastText,
    boxShadow: 'none',
    '&:disabled': {
      boxShadow: 'none',
    },
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.contrastText,
      boxShadow: 'none',
    },
  }),
}));

export default AsmubipButton;
